import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import userIcon from '@app/assets/images/icons/sys/users.svg';
import AccountList from '@modules/school-service/pages/AccountGroup/AccountPage';
import AccountRole from '@modules/school-service/pages/AccountGroup/AccountRolePage';
import AccountPrivilege from '@modules/school-service/pages/AccountGroup/AccountPrivilegePage';
import { IRouteConfig } from '../route.types';

/**
 * Người dùng
 */
const accountRoutes: IRouteConfig[] = [
    {
        name: 'NHÂN SỰ',
        icon: userIcon,
        isMenu: true,
        isRoute: false,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        children: [
            {
                name: 'Danh sách tài khoản',
                link: '/accounts',
                path: '/accounts',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.ACCOUNTS,
                main: () => <AccountList />,
            },
            {
                name: 'Cấp quyền sử dụng',
                link: '/account-privilege',
                path: '/account-privilege',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.ACCOUNT_PRIVILEGE,
                main: () => <AccountPrivilege />,
            },
            {
                name: 'Vai trò',
                link: '/account-role',
                path: '/account-role',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.ACCOUNT_ROLE,
                main: () => <AccountRole />,
            },
        ],
    },
];

export default accountRoutes;
